<template>
<div>
        <div class="bar flex relative " id="Navbar">
          <div class="logo ">
            <a href="https://www.leaseback.de">
              <svg width="330px" height="90px" viewBox="0 0 330 80" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
<title>Group</title>
 
  <g id="Unterzeile">
    <path class="cls-3" fill="#999" d="m280.54,67.75v-5.67c0-1.45-.1-2.19-.36-2.69-.56-1.07-1.59-1.71-2.83-1.71-1.35,0-2.13.52-3.15,2.07v-1.81h-1.41v9.81h1.53v-5.39c0-1.93,1.15-3.36,2.75-3.36,1.31,0,2.03.86,2.03,2.45v6.31h1.43Zm-20.83-8.82c.8,0,1.57.4,2.07,1.06.48.68.7,1.55.7,2.89,0,2.43-1.04,3.88-2.75,3.88s-2.73-1.43-2.73-3.96c0-1.19.24-2.15.68-2.79.46-.66,1.25-1.08,2.03-1.08m.06-1.25c-2.63,0-4.44,2.09-4.44,5.13s1.71,5.19,4.28,5.19,4.54-2.11,4.54-5.05c0-3.2-1.71-5.27-4.38-5.27m-13.02-3.2h-1.65v1.69h1.65v-1.69Zm-.06,3.46h-1.53v9.81h1.53v-9.81Zm-9.49,8.76c-.54.1-.82.12-1.17.12-1.06,0-1.59-.52-1.59-1.53v-6.15h2.21v-1.19h-2.21v-2.59l-1.43.12-.06,2.47h-1.73v1.19h1.73v5.91c0,1.97.95,2.98,2.8,2.98.46,0,.78-.02,1.45-.12v-1.21Zm-15.12-3.86c.02.26.02.46.02.64,0,1.89-1.37,3.36-3.17,3.36-1.27,0-2.09-.7-2.09-1.75,0-1.49,1.39-2.29,3.94-2.29.24,0,.76.02,1.29.04m1.69,4.92c-.16-.6-.22-1.19-.22-1.91v-4.16c0-1.43-.18-2.21-.65-2.87-.58-.77-1.57-1.15-3.04-1.15-1.63,0-2.87.4-3.64,1.19-.42.42-.6.8-.74,1.53l1.41.24c.26-1.17,1.15-1.79,2.63-1.79,1.87,0,2.57.68,2.57,2.53v.32c-.62-.04-.92-.04-1.27-.04-1.71,0-3.05.24-3.94.72-1.01.52-1.65,1.57-1.65,2.69,0,1.75,1.39,2.96,3.42,2.96,1.67,0,2.65-.58,3.44-2.03.08,1.11.08,1.29.18,1.77h1.51Zm-17.09,0v-9.81h-1.53v5.53c0,1.81-1.21,3.28-2.73,3.28-.54,0-1.07-.24-1.43-.68-.34-.4-.5-.98-.5-1.87v-6.27h-1.53v6.27c0,2.37,1.23,3.8,3.22,3.8,1.38,0,2.43-.73,3.13-2.13v1.87h1.37Zm-17.13-13.27h-1.53v13.27h1.53v-13.27Zm-12.44,8.36c.02.26.02.46.02.64,0,1.89-1.37,3.36-3.17,3.36-1.27,0-2.09-.7-2.09-1.75,0-1.49,1.39-2.29,3.94-2.29.24,0,.76.02,1.29.04m1.69,4.92c-.16-.6-.22-1.19-.22-1.91v-4.16c0-1.43-.18-2.21-.66-2.87-.58-.77-1.57-1.15-3.04-1.15-1.63,0-2.87.4-3.64,1.19-.42.42-.6.8-.74,1.53l1.41.24c.26-1.17,1.15-1.79,2.63-1.79,1.87,0,2.57.68,2.57,2.53v.32c-.62-.04-.92-.04-1.27-.04-1.71,0-3.05.24-3.94.72-1.01.52-1.65,1.57-1.65,2.69,0,1.75,1.39,2.96,3.42,2.96,1.67,0,2.65-.58,3.44-2.03.08,1.11.08,1.29.18,1.77h1.51Zm-15-13.27h-1.45l-3.66,10.94-3.7-10.94h-1.73l4.48,13.27h1.59l4.48-13.27Z"/>
    <path class="cls-3" fill="#999" d="m129.99,59.53c-1-1.57-1.18-1.97-1.18-2.61,0-.84.7-1.47,1.63-1.47.99,0,1.75.74,1.75,1.69,0,.82-.44,1.37-1.61,2.05-.12.06-.34.2-.6.34m2.51,6.17c-.88.8-1.53,1.05-2.61,1.05-1,0-1.97-.4-2.47-1.01-.36-.44-.54-1.04-.54-1.75,0-1.41.6-2.15,2.43-2.99l3.19,4.7Zm4.42.66c-.72.06-.96.08-1.21.08-.62,0-.96-.14-1.47-.68,1.06-1.08,2.19-3.4,2.45-4.98l-1.41-.3c-.32,1.77-.85,3.03-1.81,4.24l-2.78-4.24c2.03-1.01,2.78-1.95,2.78-3.44,0-1.67-1.25-2.82-3.06-2.82s-2.98,1.17-2.98,2.78c0,.82.38,1.69,1.27,3.01-2.21.76-3.44,2.21-3.44,4.06,0,2.27,1.93,3.94,4.52,3.94,1.37,0,2.25-.32,3.5-1.31,1.09,1.05,1.35,1.19,2.21,1.19.44,0,.7-.02,1.45-.14v-1.39Z"/>
    <path class="cls-3" fill="#999" d="m98.59,61.84c.1-.94.26-1.41.7-1.97.54-.66,1.25-1.02,2.11-1.02s1.53.34,2.03,1.04c.4.58.54,1.04.56,1.95h-5.39Zm5.47,2.98c-.22.52-.38.8-.6,1.04-.5.58-1.25.9-2.05.9-1.06,0-2.07-.6-2.51-1.49-.3-.62-.4-1.13-.4-2.29h7.14c-.02-1.35-.18-2.17-.58-3.02-.7-1.43-2.05-2.27-3.7-2.27-2.69,0-4.56,2.13-4.56,5.21s1.81,5.11,4.5,5.11c1.99,0,3.52-1.07,4.16-2.88l-1.41-.3Zm-16.9-.52c-.32,1.61-1.15,2.45-2.39,2.45-1.63,0-2.59-1.47-2.59-3.94s.99-3.88,2.61-3.88c.76,0,1.41.34,1.85.94.26.38.4.74.52,1.49l1.37-.26c-.4-2.23-1.71-3.42-3.72-3.42-2.55,0-4.22,2.07-4.22,5.17s1.63,5.15,4.14,5.15c1.1,0,1.95-.34,2.65-1.05.64-.64.92-1.21,1.15-2.41l-1.37-.24Zm-15.8,3.44v-5.67c0-1.45-.1-2.19-.36-2.69-.56-1.07-1.59-1.71-2.82-1.71-1.35,0-2.13.52-3.15,2.07v-1.81h-1.41v9.81h1.53v-5.39c0-1.93,1.15-3.36,2.75-3.36,1.31,0,2.03.86,2.03,2.45v6.31h1.43Zm-19.24-4.91c.02.26.02.46.02.64,0,1.89-1.37,3.36-3.17,3.36-1.27,0-2.09-.7-2.09-1.75,0-1.49,1.39-2.29,3.94-2.29.24,0,.76.02,1.29.04m1.69,4.92c-.16-.6-.22-1.19-.22-1.91v-4.16c0-1.43-.18-2.21-.66-2.87-.58-.77-1.57-1.15-3.04-1.15-1.63,0-2.87.4-3.64,1.19-.42.42-.6.8-.74,1.53l1.41.24c.26-1.18,1.16-1.79,2.63-1.79,1.87,0,2.57.68,2.57,2.53v.32c-.62-.04-.92-.04-1.27-.04-1.71,0-3.05.24-3.94.71-1.01.52-1.65,1.57-1.65,2.69,0,1.75,1.39,2.96,3.42,2.96,1.67,0,2.65-.58,3.44-2.03.08,1.11.08,1.29.18,1.77h1.51Zm-17.69,0v-5.67c0-1.45-.1-2.19-.36-2.69-.56-1.07-1.59-1.71-2.83-1.71-1.35,0-2.13.52-3.15,2.07v-1.81h-1.41v9.81h1.53v-5.39c0-1.93,1.15-3.36,2.75-3.36,1.31,0,2.03.86,2.03,2.45v6.31h1.43Zm-17.69-13.27h-1.65v1.69h1.65v-1.69Zm-.06,3.46h-1.53v9.81h1.53v-9.81ZM1.65,67.75v-6.29h5.37v-1.33H1.65v-4.2h6.47v-1.45H0v13.27h1.65Z"/>
  </g>
  <g id="Logo">
    <path class="cls-2" fill="#0079c0" d="m275.95,4.96C269.85,0,263.54,0,258.98,0h-21.53v44.87h17.5c6.64,0,15.7,0,22.14-6.44,2.35-2.42,6.37-7.72,6.37-16.3,0-9.53-4.76-14.82-7.51-17.17m-4.63,26.5c-3.76,4.83-9.19,5.23-14.89,5.23h-9.79V8.12h12.47c3.76.07,7.85.13,11.27,3.49,1.48,1.41,3.89,4.63,3.89,10.4-.07,2.55-.54,6.3-2.95,9.46"/>
    <rect class="cls-1" fill="#0077cd" x="215.99" y="0" width="9.26" height="44.87"/>
    <path class="cls-1" fill="#0077cd" d="m200.56,21c1.74-1.27,3.96-3.76,3.96-8.52,0-2.89-.8-5.3-2.41-7.44C198.14,0,191.37,0,187.28,0h-26.76v44.87h26.76c4.56,0,10.8,0,15.03-3.55,2.75-2.28,4.29-5.77,4.29-9.66.06-3.55-1.28-7.85-6.04-10.66m-30.85-12.95h17.64c2.01,0,4.29,0,5.97,1.07,1.27.87,1.94,2.15,1.94,3.82,0,1.41-.54,3.15-2.08,4.03-1.34.74-3.22.74-4.9.74h-18.58v-9.66Zm25.89,27.17c-1.74,1.54-4.09,1.61-6.51,1.61h-19.45v-11.2h19.45c2.48,0,4.69.13,6.37,1.34.54.47,1.88,1.61,1.88,4.16,0,.74,0,2.68-1.74,4.09"/>
    <polygon class="cls-1" fill="#0077cd" points="109 0 109 8.19 126.04 8.19 126.04 44.87 135.09 44.87 135.09 8.19 152.2 8.19 152.2 0 109 0"/>
    <g id="Ebene_2" data-name="Ebene 2">
      <rect class="cls-1" fill="#0077cd" x="57.08" y="0" width="43.2" height="8.18"/>
      <rect class="cls-1" fill="#0077cd" x="57.08" y="18.38" width="43.2" height="8.12"/>
      <rect class="cls-1" fill="#0077cd" x="57.08" y="36.76" width="43.2" height="8.12"/>
    </g>
    <path class="cls-1" fill="#0077cd" d="m38.3,30.39v.4s.07.8.07,1.14c-.6-.67-1.41-1.61-1.41-1.61L8.38,0H0v44.87h8.85V15.43s-.07-1.41-.13-2.62c.07.07.33.34.33.34l30.05,31.73h8.05V0h-8.85v30.39Z"/>
  </g>
</svg> 
            </a>        
          </div>
          <div class="burger relative top-0 left-0">
              <div class="col-4 bg-white bg-shadow p4 absolute top-0 right-0 z4 menuholder" v-if="hideMenu == false" data-amp-original-style="min-width:200px">
                  <a class="absolute close top-0 p2 pt1 col-1" role="button" href="#" @click="hidemenu()">
                    <svg height="32" width="32" x="0px" y="0px" viewBox="0 0 16 15" enable-background="new 0 0 16 15" xml:space="preserve">
                      <rect x="-1" y="6" transform="matrix(0.7071 -0.7071 0.7071 0.7071 -2.7994 7.787)" fill-rule="evenodd" clip-rule="evenodd" fill="#0066CC" width="18" height="2.5"></rect>
                      <rect x="6.7" y="-1.7" transform="matrix(0.7071 -0.7071 0.7071 0.7071 -2.7994 7.787)" fill-rule="evenodd" clip-rule="evenodd" fill="#0066CC" width="2.5" height="18"></rect>
                    </svg>     
                  </a>
                  <nav class="relative top-0 left-0 mainnav">
                    <div class="menu-hauptmenu-container">
                      <ul id="menu-hauptmenu" class="menu">
                          <li class="">
                            <a class="" href="https://www.leaseback.de">Startseite</a>
                          </li>
                          <li class="">
                            <a class="" href="https://onboarding.leaseback.de">Maschinenbewertung</a>
                          </li>
                          <li class="">
                              <a class="" href="https://www.leaseback.de/produkte-losungen/">Produkte &amp; Lösungen</a>
                          </li>
                          <li class="">
                              <a class="" href="https://www.leaseback.de/unternehmen/">Unternehmen</a>
                          </li>
                          <li class="">
                            <a class="" href="https://www.leaseback.de/presse/">Presse</a>
                          </li>
                          <li class="">
                            <a class="" href="https://www.leaseback.de/kontakt/">Kontakt</a>
                          </li>
                        </ul>
                    </div>               
                  </nav>

            </div>
            <a class="burgericon absolute top-0 right-0 col-4 p2" role="button" href="#" @click="showmenu()">
              <svg height="32" width="32" x="0px" y="0px" viewBox="0 0 17 14" enable-background="new 0 0 17 14" xml:space="preserve">
                <rect y="5.7" fill-rule="evenodd" clip-rule="evenodd" fill="#0066CC" width="17" height="2.5"></rect>
                <rect y="11.5" fill-rule="evenodd" clip-rule="evenodd" fill="#0066CC" width="17" height="2.5"></rect>
                <rect fill-rule="evenodd" clip-rule="evenodd" fill="#0066CC" width="17" height="2.5"></rect>
              </svg>
              </a>
          </div>
      </div>
     <div id="navbarcloseholder" v-if="hideMenu == false"  @click="hidemenu()"></div>
     </div>
</template>

<script>


export default {
  name: "Burger",
  data(){
    return {
      hideMenu: true,
    }
  },
  methods: {
    hidemenu(){
      this.hideMenu = true;
    },
    showmenu(){
      this.hideMenu = false;
    }
  }
};

</script>
<style>
#navbarcloseholder {
  width: 100%;
  height: 100%;
  background-color: transparent;
  display: inline;
  position: absolute;
  top: 0px;
  bottom: 0px;
  left: 0px;
  right: 0px;
}

nav.mainnav * {
    font-size: 1.2rem;
    color: black;
    line-height: 2.5;
    font-weight: 300;
}
.burger a:visited{color: black;}
.burger a:hover{color: #0176CD;}
ul {
    list-style: none;
    padding-left: 0;
    font-weight: 300;
    margin: 1.333rem 0;
}
a.absolute.close {
    right: .5rem;
}
.menuholder{
  min-width: 200px;
}
.bg-shadow {
    box-shadow: 0 4px 16px -8px rgba(0,0,0,.7);
}
.burgericon:after, .close:after{
    position: absolute;
    top: 24px;
    text-align: center;
    color: #0176CD;
    font-weight: 700;
    font-size: .8rem;
    padding-top: 24px;
    box-sizing: border-box;
    -webkit-box-sizing: border-box;
}
.close:after {
  content: "Schließen";
}
.burgericon:after{
  content:'Menü';
  left: 16px;
}
.close:after {
    text-align: right;
    right: 0;
}
.logo a svg {max-width:100%}
.logo{
  display:flex;
  left: auto;
  transform:none;
  top: auto;
  width:30%;
  z-index: 2;
}
.logo a svg {
  max-width:100%
}

#Navbar{
  max-width: 1280px;
}

@media (max-width: 1320px) {
  #Navbar {
    max-width: 1000px;
  }
}

@media (max-width: 1060px) {
  #Navbar {
    max-width: 800px;
    padding: 0 2.5%;
  }
}

@media (max-width: 768px) {
  #Navbar {
    max-width: 800px;
    margin-right: auto;
    margin-left: auto;
  }
}

a.absolute.close{    
  right: 0.5rem;
}
.close:after {
  text-align: right;
  right: 0;
}
</style>
